<template>
  <div>
    <div class="record" style="padding: 10px;">
      <p class="title" style="font-size: 25px;color: #fff;">
        {{ $t("寺院账户") }}
      </p>
      <el-row class="lianxi" :gutter="10">
        <el-col :span="5" :lg="5" :xl="5" :xs="24" :sm="24"
          ><p>{{ $t("香港地区") }}</p>
          <p>{{ $t("ZA Bank Limited") }}</p>
          <p>{{ $t("银行编号:387") }}</p>
          <!-- <p>{{ $t("分行编号:747") }}</p> -->
          <p>{{ $t("帳號: 887066659325") }}</p>
          <p>{{ $t("戶名: LIANG JIAHUI") }}</p></el-col
        >
        <el-col :span="5" :lg="5" :xl="5" :xs="24" :sm="24"
          ><p>{{ $t("香港地区") }}</p>
          <p>{{ $t("建设银行（亚洲） (CCB) ") }}</p>
          <p>{{ $t("户名：香港看經佛事工藝品貿易有限公司") }}</p>
          <p>{{ $t("账号: 846210425034") }}</p>
        </el-col>
        <el-col :span="4" :lg="4" :xl="4" :xs="24" :sm="24">
          <p>{{ $t("新加坡地区") }}</p>
          <p>{{ $t("大华银行") }}</p>
          <p>{{ $t("UnitedOverseasBank") }}</p>
          <p>
            {{ $t("账号: 3733237234") }}
          </p>
          <p>{{ $t("户名：zhuangchangsai") }}</p>
        </el-col>
        <el-col :span="5" :lg="5" :xl="5" :xs="24" :sm="24">
          <p>{{ $t("马来西亚地区") }}</p>
          <p>{{ $t("点击扫码进行TNG支付") }}</p>
          <el-image
            style="width: 50px; height: 50px; margin-top: 5px"
            :src="require('@/assets/home/malai.png')"
            :preview-src-list="[require('@/assets/home/malai.png')]"
          ></el-image>
          <p>{{ $t("TNG：+60 186643583") }}</p>
        </el-col>
        <el-col :span="5" :lg="5" :xl="5" :xs="24" :sm="24">
          <p>{{ $t("马来西亚地区") }}</p>
          <p>{{ $t("马来银行账户名称") }}</p>
          <p>{{ $t("AFFIN BANK ") }}</p>
          <p>
            {{ $t("账号：200440094780") }}
          </p>
          <p>{{ $t("户名：LAIFUTAO") }}</p>
        </el-col>
      </el-row>
      <p style="font-size: 18px;color: #fff;">
                {{ $t("其他地区善信发心，可联系客服了解拨款方式") }}
              </p>
                  <p style="text-align: center; padding: 5px; color: #fff;font-weight: bold;font-size: 20px;">
      {{ $t("網路助印/募緣等全部盈利會充作本寺建設基金") }}
    </p>
    <p style="text-align: center; padding: 5px; color: #fff;font-weight: bold;font-size: 20px;">
      All Profits/Net Proceeds will go to The Temple Building Fund
    </p>
    </div>
    <div class="record" >
      <el-row class="lianxi" :gutter="10">
        <el-col :span="10" :xs="24" :sm="24" :md="24" :lg="10" :xl="10">
          <div class="left">
            <div class="left-dw" style="font-size: 18px;">
                  <p>{{ $t("邮编：315012") }}</p>
                  <p>{{ $t("微信客服：17675702568") }}</p>
                  <p>{{ $t("邮箱：NBkanjingsi@163.com") }}</p>
                  <p>{{ $t("电话：0574-87463108（客堂）") }}</p>
                  <p @click="WindowOpens('https://www.nbkjs.com')">
                    {{ $t("官网网址www.nbkjs.com") }}
                  </p>
            </div>
          </div>
        </el-col>
        <el-col
          :span="4"
          :lg="4"
          :xl="4"
          :xs="24"
          :sm="24"
          :md="24"
          v-if="!mobile"
        >
          <div class="conter">
            <el-image :src="require('@/assets/home/logoft.png')" lazy />
          </div>
        </el-col>
        <el-col :span="10" :lg="10" :xl="10" :xs="24" :sm="24" :md="24">
          <div class="right">
            <div class="right-dw">
              <el-row :gutter="20">
                <el-col
                  :span="5"
                  :lg="5"
                  :xl="5"
                  :xs="12"
                  :sm="12"
                  :md="12"
                  style="text-align: center"
                  :offset="mobile ? 0 : 6"
                >
                  <div style="margin-bottom: 20px">
                    <el-image
                      :src="require('@/assets/home/whats.png')"
                      style="width: 70px; height: 70px"
                    />
                    <span style="display: block; text-align: center"
                      >whatsapp</span
                    >
                  </div>
                  <div>
                    <a
                      class="a-btn2"
                      href="https://diversion.salesmartly.com/split/whatsapp/er615a"
                      style="background-color: #25d366"
                    >
                      <el-image
                        :src="require('@/assets/home/whatsappicon.png')"
                        style="
                          vertical-align: middle;
                          width: 20px;
                          height: 20px;
                        "
                      />
                    </a>
                  </div>
                </el-col>
                <el-col :span="5" :lg="5" :xl="5" :xs="12" :sm="12" :md="12">
                  <div style="margin-bottom: 20px">
                    <el-image
                      :src="require('@/assets/home/wxsfx.png')"
                      style="width: 70px; height: 70px"
                    />
                    <span style="display: block; text-align: center">微信</span>
                  </div>
                  <div>
                    <a
                      class="a-btn2"
                      @click="
                        WindowOpens(
                          'https://www.facebook.com/profile.php?id=61564820916130',
                        )
                      "
                    >
                      <el-image
                        :src="require('@/assets/home/lian.png')"
                        style="
                          vertical-align: middle;
                          width: 20px;
                          height: 20px;
                        "
                      />
                    </a>
                  </div>
                </el-col>
                <el-col :span="8" :lg="8" :xl="8" :xs="24" :sm="24" >
                  <div>
                    <p>
                      <a style="color: #fff" href="https://www.nbkjs.com"
                        >寧波看經寺官方網站</a
                      >
                    </p>
                    <p>
                      <a
                        style="color: #fff"
                        href="https://www.youtube.com/@寧波看經寺"
                        >YouTube頻道訂閱</a
                      >
                    </p>

                    <p>
                      <a
                        style="color: #fff"
                        href="https://www.facebook.com/shifaxu2024"
                        >釋法續Facebook專頁</a
                      >
                    </p>

                    <p>
                      <a
                        style="color: #fff"
                        href="https://www.facebook.com/nbkjs2024"
                        >寺院Facebook專頁</a
                      >
                    </p>
                  </div>
                </el-col>
              </el-row>
              <!-- <div style="margin-top: 20px">
                <el-row :gutter="10">
                  <el-col :span="6" :xs="12" :offset="mobile ? 0 :10">
                    <a
                      class="a-btn2"
                      href="https://diversion.salesmartly.com/split/whatsapp/er615a"
                      style="background-color: #25d366"
                    >
                      <el-image
                        :src="require('@/assets/home/whatsappicon.png')"
                        style="
                          vertical-align: middle;
                          width: 20px;
                          height: 20px;
                        "
                      />
                    </a>
                  </el-col>
                  <el-col :span="6" :xs="12">
                    <a
                      class="a-btn2"
                      @click="
                        WindowOpens(
                          'https://www.facebook.com/profile.php?id=61564820916130'
                        )
                      "
                    >
                      <el-image
                        :src="require('@/assets/home/lian.png')"
                        style="
                          vertical-align: middle;
                          width: 20px;
                          height: 20px;
                        "
                      />
                    </a>
                  </el-col>
                </el-row>
              </div> -->
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <p style="text-align: center; padding: 5px">
      {{
        $t(
          "互联网宗教信息服务许可证：浙（2025）0000308 版权声明： 2025-2028 看经寺",
        )
      }}
    </p>
    <p style="text-align: center; padding: 5px">
      {{ $t("（国家宗教事务局监制）") }}
    </p>
  </div>
</template>

<script>
import { deviceJudgment } from "@/utils/index.js";

export default {
  name: "WebsiteEnd",
  components: {},
  data() {
    return {
      mobile: deviceJudgment(),
    };
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    WindowOpens(url) {
      window.open(url);
    },
  },
};
</script>

<style lang="scss" scoped></style>
